import { call, put, takeEvery } from "redux-saga/effects";

import { ResponseGenerator } from "../../interfaces";
import {
  GENERATE_SEQUENCE_NUMBER,
  GenerateSequenceNumberAction,
  GET_APP_SETTINGS,
  GetAppSettingsAction,
  UPDATE_APP_SETTINGS,
  UpdateAppSettingsAction,
} from "./actionTypes";
import {
  generateSequenceNumberError,
  generateSequenceNumberSuccess,
  getAppSettingsError,
  getAppSettingsSuccess,
  updateAppSettingsError,
  updateAppSettingsSuccess,
} from "./actions";
import {
  generateSequenceRequest,
  getAppSettings,
  updateAppSettings,
} from "../../helpers/backend_helper";

function* getAppSettingsSaga({
  payload: { type, history },
}: GetAppSettingsAction) {
  try {
    const response: ResponseGenerator = yield call(getAppSettings, type);
    yield put(getAppSettingsSuccess(response.data));
  } catch (error) {
    yield put(getAppSettingsError(error));
  }
}

function* updateAppSettingsSaga({
  payload: { type, request, history },
}: UpdateAppSettingsAction) {
  try {
    const response: ResponseGenerator = yield call(
      updateAppSettings,
      type,
      request
    );
    yield put(updateAppSettingsSuccess(response.data));
  } catch (error) {
    yield put(updateAppSettingsError(error));
  }
}

function* generateSequenceNumberSaga({
  payload,
}: GenerateSequenceNumberAction) {
  try {
    const response: ResponseGenerator = yield call(
      generateSequenceRequest,
      payload
    );
    yield put(generateSequenceNumberSuccess(response.data));
  } catch (error) {
    yield put(generateSequenceNumberError(error));
  }
}

function* AppSettingsSaga() {
  yield takeEvery(GET_APP_SETTINGS, getAppSettingsSaga);
  yield takeEvery(UPDATE_APP_SETTINGS, updateAppSettingsSaga);
  yield takeEvery(GENERATE_SEQUENCE_NUMBER, generateSequenceNumberSaga);
}

export default AppSettingsSaga;
